import { render, staticRenderFns } from "./SerieResultsView.vue?vue&type=template&id=47b8affc&"
import script from "./SerieResultsView.vue?vue&type=script&lang=js&"
export * from "./SerieResultsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports